import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MfaPage } from '@/features/auth';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/login_/mfa')({
  validateSearch: z.object({ redirect: zSearchText() }),
  component: function Mfa() {
    const { redirect } = Route.useSearch();
    return <MfaPage redirect={redirect} />;
  },
});
